
import React, { useState } from "react";
import Header from "../home/header";
import Dashboard from "./dashboard";
import SidebarComponent from "../../pages/SidebarComponent";
import { GoogleAd } from "../ads/GoogleAd";
import { useScreen } from "../../contexts/screen.provider";

function DashboardPage() {
  const { isMobile, isDesktop } = useScreen();
  const [displaySidebar, setDisplaySidebar] = useState(false);
  function changeSidebarDisplay() {
    setDisplaySidebar(prev => !prev);
  }



  return (
    <div className="w-full overflow-y-auto  h-screen custom-scrollbar  bg-white dark:bg-[#212121] flex flex-col ">
      <Header
        isAdsVisible={true}
        sidebarDisplay={displaySidebar}
        changeSidebarDisplay={changeSidebarDisplay}
      />
      <main className="flex mt-[6vh] md:mt-[7vh] tablet:mt-[10vh] gap-2  tablet:px-4 px-4    flex-col items-center  tablet:items-start  tablet:flex-row flex-grow relative">
        <SidebarComponent setSidebarDisplay={setDisplaySidebar} sidebarDisplay={displaySidebar} />
        {!isMobile && <GoogleAd />}
        <Dashboard />
        {
          isDesktop
            ?
            <GoogleAd />
            : <div className="h-full w-full ">
              <GoogleAd />
            </div>
        }
      </main>
    </div>

  )
}

export default DashboardPage;